import React from "react";
import { motion } from "framer-motion";
import { useLang } from "../i18n";
import { WHY } from "../data/content";
import { GlowCard } from "../components/fx/GlowCard";
import { Icon } from "../components/Icon";
import { SectionHeading } from "../components/SectionHeading";
import { stagger, item } from "../components/fx/Reveal";

export const WhyVoltpdr = () => {
  const { lang, L } = useLang();
  return (
    <section className="relative z-10 bg-ink py-24 md:py-32">
      <div className="container-pdr">
        <SectionHeading
          label={lang === "ro" ? "De ce VOLTPDR" : "Why VOLTPDR"}
          title={lang === "ro" ? "Standarde de engineering, nu doar cabluri." : "Engineering standards, not just cables."}
          desc={lang === "ro"
            ? "Fiecare proiect este tratat ca o infrastructură critică — cu rigoare tehnică, materiale certificate și tehnologie modernă."
            : "Every project is treated as critical infrastructure — with technical rigor, certified materials and modern technology."}
        />

        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-80px" }}
          className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-4"
        >
          {WHY.map((w, i) => (
            <motion.div key={i} variants={item}>
              <GlowCard className="h-full p-7" data-testid={`why-card-${i}`}>
                <div className="flex h-12 w-12 items-center justify-center rounded-xl border border-glow-2/25 bg-glow-2/10 text-glow-2">
                  <Icon name={w.icon} className="h-6 w-6" />
                </div>
                <span className="mt-6 block font-mono text-xs text-white/30">0{i + 1}</span>
                <h3 className="mt-1 font-display text-xl font-bold text-white">{L(w)?.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-white/55">{L(w)?.desc}</p>
              </GlowCard>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
